import { Injectable, Output, EventEmitter } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ALERT_TYPES } from './alert-types.enum';
import { Alert } from './alert.class';

@Injectable({ providedIn: 'root' })
export class AlertService {
	@Output() readonly remove: EventEmitter<Alert> = new EventEmitter();

	keepAfterRouteChange = false;
	private readonly subject = new Subject<Alert>();

	constructor(private readonly router: Router) {
		// clear alert messages on route change unless 'keepAfterRouteChange' flag is true
		router.events?.subscribe((event) => {
			if (event instanceof NavigationStart) {
				if (this.keepAfterRouteChange) {
					// only keep for a single route change
					this.keepAfterRouteChange = false;
				} else {
					// clear alert messages
					this.clear();
				}
			}
		});
	}

	getAlert(): Observable<Alert> {
		return this.subject.asObservable();
	}

	success(message: string, keepAfterRouteChange = false): void {
		this.alert(ALERT_TYPES.Success, message, keepAfterRouteChange);
	}

	error(message: string, keepAfterRouteChange = false): void {
		this.alert(ALERT_TYPES.Error, message, keepAfterRouteChange);
	}

	info(message: string, keepAfterRouteChange = false): void {
		this.alert(ALERT_TYPES.Info, message, keepAfterRouteChange);
	}

	warn(message: string, keepAfterRouteChange = false): void {
		this.alert(ALERT_TYPES.Warning, message, keepAfterRouteChange);
	}

	clear(): void {
		// clear alerts
		this.subject.next(null);
	}

	private alert(
		type: ALERT_TYPES,
		message: string,
		keepAfterRouteChange = false
	): void {
		const alert = new Alert(type, message);
		this.keepAfterRouteChange = keepAfterRouteChange;
		this.subject.next(alert);
	}
}
